import React, { PureComponent, Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GroupBuyingRule from '../components/groupBuyingRule';
import GroupBuyingProgress from '../components/groupBuyingProgress';

import {
    View,
    StyleSheet,
		Dimensions
} from 'react-native';

import {
    JDTouchable,
    JDText,
    JDImage,
    JDScrollView,
    JDLogin,
    JDJumping,
    JDConfirmDialog,
    JDCountDown,
		JDDevice
} from '@jdreact/jdreact-core-lib';
import {
    utils,
    Link,
    NavBar,
    GradientNavBar
} from '@ltfe/ltfe-core-lib';
import {
    tip,
    complement,
    mtaPV,
    mta,
    closeShare,
    time_str
} from '../common/utils';
import { get, post } from '../common/fetch';
import Loading from '../components/common/loading';
// import CountDown from '../components/common/count-down';
import OrderAddr from '../components/orderDetail/order-addr';
import OrderCoupon from '../components/orderDetail/order-coupon';
import WifiOut from '../components/common/wifi-out';
import ToIndex from '../components/common/to-index';
import sgmReport from '../common/sgmUtil';

const { pt } = utils;

class OrderDetail extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            // detailInfo: {
            //     "code": 0,
            //     "data": {
            //         "cinemaAddress": "北京市朝阳区双桥路3号东星时尚广场5楼",
            //         "cinemaId": 74008,
            //         "cinemaLat": 39.90536,
            //         "cinemaLon": 116.57738,
            //         "cinemaName": "金逸影城北京双桥店",
            //         "cinemaPhone": "010-59769805",
            //         "discountFeeMoney": 0,
            //         "hallName": "8号高清激光厅",
            //         "jdPicAddr": "https://img14.360buyimg.com/movie/jfs/t1/2515/9/9192/641011/5bac0f70E63ac2d41/aaab64fab8e230e6.jpg",
            //         "language": "印度语",
            //         "leftTimeStamp": null,
            //         "movieId": "75752",
            //         "movieName": "嗝嗝老师",
            //         "onlinePayFeeMoney": 0,
            //         "orderNo": "80833743071",
            //         "orderPayTime": 1539859250000,
            //         "orderStatus": 5,
            //         "orderStatusDesc": "已完成",
            //         "playType": "2D",
            //         "qrCodeUrl": "//img14.360buyimg.com/movie/jfs/t1/5665/32/9761/2276/5bc88774Ed6ffb910/ed79d3163eb21f4b.png",
            //         "seats": ["6排2座"],
            //         "starLevel": -1,
            //         "ticketCode": "WHMRMHQ",
            //         "timestamp": "1539871800000"
            //     },
            //     "errCode": null,
            //     "errMsg": null,
            //     "success": true
            // },
            detailInfo: {},
            isShowConfirm: false,
            loading: true,
            // loading: false,
            cancelOrder: false,
            statusMap: {
                1: '待付款',
                2: '出票中',
                3: '已取消',
                4: '出票失败',
                5: '已完成', // 出票成功
                6: '退款中',
                7: '退款成功',
                8: '等待付款确认'
            },
            shareInfo: {},
            hasError: false,
            minutes: 0,
            seconds: 0,
            setZindex: false, // 证件照弹框弹起时修改层级
	          detailsHeight: 0,
	          shadowBean: false, // 是否是影豆详情
            // 拼场电影相关信息
            scheduledPlayStatusMap:{
                1: '拼场失败，已退款',
                2: '拼场失败，退款中',
                3: '拼场成功，已出票',
                4: '预约成功，拼场中',
                5: '拼场成功，出票中',
            },
            isScheduledPlay: false,
            scheduledPlayStatus: 0,
            scheduledPlayInfo: {},
        };
        this.goPay = this.goPay.bind(this);
        this.getDate = this.getDate.bind(this);
        this.getLeftTime = this.getLeftTime.bind(this);
        this.getDetail = this.getDetail.bind(this);
        this._cancelOrder = this._cancelOrder.bind(this);
        this._agreeCancel = this._agreeCancel.bind(this);
        this._onClose = this._onClose.bind(this);
        this.overDeadTime = this.overDeadTime.bind(this);
        this.refresh = this.refresh.bind(this);
	      this.getCardSize = this.getCardSize.bind(this);
        this.handleScheduledPlay = this.handleScheduledPlay.bind(this);
    }

    static defaultProps = {
        erpOrderId: ''
    }

    render() {
        const { data } = this.state.detailInfo;
        const { loading, cancelOrder, statusMap, shareInfo, hasError, seconds, minutes, setZindex, scheduledPlayStatusMap, isScheduledPlay, scheduledPlayStatus, scheduledPlayInfo } = this.state;
        const hallInfo = data && (data.language + data.playType + ' ' + data.hallName);
        const { erpOrderId } = this.props;
		    const orderStatus = data?.orderStatus || 0;
		    const orderStatusText = this.state.statusMap[orderStatus];
		    const movieBeanMoney = data?.movieBeanMoney || 0;
		    const onlinePayAmount = data?.onlinePayAmount || 0;
		    // 只在线支付, 是 影豆没有
		    const onlinePayment = movieBeanMoney <=0 && onlinePayAmount > 0;
		    // 仅影豆支付
		    const shadowBeanPay = movieBeanMoney > 0 && onlinePayAmount <= 0;
		    // 影豆和在线组合
		    const portfolioPayment = movieBeanMoney > 0 && onlinePayAmount > 0;
			// 拼场电影提示
            const scheduledPlayStatusText = scheduledPlayStatusMap[scheduledPlayStatus] || '';
        if (hasError) {
            return (
                <View style={ st.context }>
                    { this.setTitle('订单详情') }
                    <WifiOut refresh={ this.refresh } contentStyle={ { flex: 1, height: '100%', backgroundColor: '#fff' } } />
                </View>
            );
        }

        return (
		        <View style={ st.wrap }>
				        <PageBgt
						        shadowBean={this.state.shadowBean} />
				        {
						        this.state.shadowBean
								        ? <ShadowBeanHeader
										        orderStatusText={orderStatusText}
										        shadowBean={this.state.shadowBean}
										        goBack={ ()=> this.context.router.goBack() } />
								        : this.setTitle('订单详情')
				        }
				        {!loading
						        ? <JDScrollView showsVerticalScrollIndicator={ false }>
								        {
										        this.state.shadowBean ?
												        <View style={yd.boxTop} onLayout={ this.getCardSize }>
														        {
																        data.orderStatus === 1 && <View style={yd.timeTop}>
																		        <View style={yd.timeStyle}>
																				        <CountDown
																						        shadowBean={this.state.shadowBean}
																						        thetime={ data.leftTimeStamp }
																						        timeOut={ this.getDetail } />
																		        </View>
																		        <View style={yd.timeBtnGroup}>
																				        <JDTouchable onPress={ () => this._cancelOrder() }>
																						        <JDText style={yd.timeBtn}>取消订单</JDText>
																				        </JDTouchable>
																				        <JDTouchable onPress={ () => this.goPay() }>
																						        <JDText style={yd.timeBtn}>去支付</JDText>
																				        </JDTouchable>
																		        </View>
																        </View>
														        }
														        <View style={yd.cardBoxTop}>
																        <View style={yd.cardBoxTopBox}>
																		        <View style={yd.cardBoxTopBoxLeft}>
																				        <JDText style={yd.cardBoxTopBoxLeftTitle}>
																						        {data.goodsName}
																				        </JDText>
																				        <View style={yd.cardBoxTopBoxLeftTextGroup}>
																						        <View style={yd.grayTextTop}>
																								        <JDText style={yd.grayText}>商品类型:</JDText>
																								        <JDText style={yd.grayTextValue}>影豆商城兑换商品</JDText>
																						        </View>
																						        <View style={yd.grayTextTop}>
																								        <JDText style={yd.grayText}>购买数量:</JDText>
																								        <JDText style={yd.grayTextValue}>{data?.goodsNum || 1}</JDText>
																						        </View>
																				        </View>
																		        </View>
																		        <View style={yd.cardRightBox}>
																				        <JDImage
																						        source={ {uri: data?.jdPicAddr || 'https://img13.360buyimg.com/imagetools/jfs/t1/113530/9/31229/8670/63903526E8d1d58f6/6bd99d020f9de9dd.png' }}
																						        style={yd.cardRightImg}></JDImage>
																		        </View>
																        </View>
														        </View>
														        <View style={yd.cardBoxTop}>
																        <View style={yd.cardBoxTopBox}>
																		        <View style={yd.cardBoxTopBoxLeft}>
																				        <JDText style={yd.cardBoxTopBoxLeftTitle}>
																						        订单详情
																				        </JDText>
																				        <View style={yd.cardBoxTopBoxLeftTextGroup}>
																						        <View style={yd.grayTextTop}>
																								        <JDText style={yd.grayText}>订单编号:</JDText>
																								        <JDText style={yd.grayTextValue}>{data.orderNo}</JDText>
																						        </View>
																						        <View style={yd.grayTextTop}>
																								        <JDText style={yd.grayText}>下单时间:</JDText>
																								        <JDText style={yd.grayTextValue}>{time_str(data.orderPayTime)}</JDText>
																						        </View>

																						        {
																								        ((data.movieBeanMoney > 0) || (shadowBeanPay || portfolioPayment)) &&  <View style={yd.grayTextTop}>
																										        <JDText style={yd.grayText}>影豆支付:</JDText>
																										        <JDText style={yd.grayTextValue}>￥{data.movieBeanMoney / 100}</JDText>
																								        </View>
																						        }
																						        {
																								        data.onlinePayFeeMoney > 0 && <View style={yd.grayTextTop}>
																										        <JDText style={yd.grayText}>实际支付:</JDText>
																										        <JDText style={yd.grayTextValue}>￥{data.onlinePayFeeMoney / 100}</JDText>
																								        </View>
																						        }
																						        {
																								        data.totalAmount > 0 && <View style={yd.grayTextTop}>
																										        <JDText style={yd.grayText}>总共金额:</JDText>
																										        <JDText style={yd.grayTextValue}>￥{data.totalAmount / 100}</JDText>
																								        </View>
																						        }

																				        </View>
																		        </View>
																        </View>
														        </View>
														        {/* 订单详情 */}
														        <OrderAddr
																        info={ data }
																        detailsHeight={this.state.detailsHeight}
																        erpOrderId={ erpOrderId }
																        shadowBean={this.state.shadowBean}
																        setZindexFun={this.setZindexFun}
														        />
												        </View>
												        :
												        <>
                                                                {isScheduledPlay && scheduledPlayStatusText && (<View style={ st.group_buying_tips }>
                                                                    <JDText style={ st.group_buying_tips_text }>{scheduledPlayStatusText}</JDText>
                                                                </View>)}
														        <View style={ st.info_wrap }>
																        <View style={ st.info_box }>
																		        <Link style={ { flexDirection: 'row' } } onPress={this.toMovieDetail}>
																				        <JDImage style={ st.movie_img } source={ { uri: data.jdPicAddr } } />
																				        <View style={ st.infos }>
																						        <JDText style={ st.info_title } NumberOfLines={ 1 } ellipsizeMode="tail" >{data.movieName}</JDText>
																						        <JDText style={ st.info_detail }>{this.getDate(data.timestamp)}</JDText>
																						        <JDText style={ st.info_detail }>{hallInfo}</JDText>
																						        <JDText style={ st.info_detail }>{data?.seats?.join('、')}</JDText>
																				        </View>
																		        </Link>
																		        <View style={ [data.orderStatus !== 1 ? st.status : st.count, data.orderStatus === 3 ? st.status_txt_grey : ''] }>
																				        {
																						        data.orderStatus === 1
																								        ? <CountDown thetime={ data.leftTimeStamp } timeOut={ this.getDetail } />
																								        : ((isScheduledPlay && scheduledPlayStatusText) ? '' : <JDText style={ [st.status_txt, data.orderStatus === 3 ? [st.status_txt_grey, { marginLeft: pt(2) }] : [st.status_txt_blue, { marginLeft: pt(2) }]] }>{statusMap[data.orderStatus + '']}</JDText>)
																				        }
																		        </View>
																        </View>

																        {
																		        data.orderStatus === 1 &&
																		        <View style={ st.opt }>
																				        <JDTouchable onPress={ () => this._cancelOrder() }>
																						        <View style={ [st.btn, st.cancel] }>
																								        <JDText style={ st.btn_txt }>取消订单</JDText>
																						        </View>
																				        </JDTouchable>
																				        <JDTouchable onPress={ () => this.goPay() }>
																						        <JDImage style={ [st.b_img, st.btn] } source={ img.go_pay_btn } />
																				        </JDTouchable>
																		        </View>
																        }

																        {
																		        data.orderStatus === 5 && (data.ticketPwd || data.ticketCode) && data.qrCodeUrl && <View style={ st.ewm }>
																				        <View style={ st.yzm }>
																						        {data.ticketCode && <JDText style={ st.yzm_txt }>序列号 {data.ticketCode}</JDText>}
																						        {data.ticketPwd && <JDText style={ st.yzm_txt }>验证码 {data.ticketPwd}</JDText>}
																				        </View>
																				        <View style={ st.ewm_img_wrap }>
																						        <JDImage style={ st.ewm_img } source={ { uri: data.qrCodeUrl } } />
																						        {
																								        this.overDeadTime() &&
																								        <View style={ st.ewm_mask } />
																						        }
																				        </View>
																		        </View>
																        }

																        {
																		        data.orderStatus == 7 &&
																		        <View style={ st.return_success }>
																				        <JDImage source={ img.return_info_icon } />
																				        <JDText style={ st.return_success_txt }>温馨提示：退款预计3-7个工作日到账</JDText>
																		        </View>
																        }
                                                                        {/* 拼团进度展示 */}
                                                                        {isScheduledPlay && scheduledPlayStatus === 4 && (<GroupBuyingProgress scheduledPlayInfo={scheduledPlayInfo} movieData={data} />)}
														        </View>
														        {/* 优惠券 */}
														        {
																        data.orderStatus === 5 &&
																        <OrderCoupon erpOrderId={ erpOrderId } />
														        }
                                                                {/* 拼团规则 */}
                                                                {isScheduledPlay && <GroupBuyingRule />}
														        {/* 订单详情 */}
														        <OrderAddr
																        info={ data }
																        erpOrderId={ erpOrderId }
																        setZindexFun={this.setZindexFun}
														        />
												        </>
								        }
						        </JDScrollView>
						        : <Loading contentStyle={ { height: '100%', width: '100%', backgroundColor: '#fff' } } />}
				        <JDConfirmDialog show={ cancelOrder } onConfirm={ this._agreeCancel } onClose={ this._onClose }>
						        <View style={ st.dialogBody }>
								        <JDText style={ st.c_title }>是否确定取消订单</JDText>
								        <JDText>取消订单后您选择的座位将会被释放，虚拟资产部分稍后会退至您的账户</JDText>
						        </View>
				        </JDConfirmDialog>
		        </View>
        );
    }

    componentDidFocus() {
        mtaPV('Order', `${this.props.movieId}_${this.props.erpOrderId}`);
    }

    componentDidMount() {
        const _this = this;

        JDLogin.isLogin().then(() => {
            jump();
        }, () => {
            JDLogin.doLogin().then(() => {
                jump();
            });
        }).catch(() => jump());

        function jump() {
            _this.getDetail();
        }
        // 该页面中有单独的订单分享，故须隐藏title中的分享按钮
        const jsonString = JSON.stringify({
            hidemore: {
                type: 'share',
                display: 'hide' // show, hide'
            }
        });

        closeShare();
    }

    getDetail() {
        const _this = this;
        const { dispatch, starLevel, erpOrderId } = this.props;

        get('getAllOrderDetail', { erpOrderId }, true).then((res) => {
            const shareInfo = {
                url: `https://m-movie.jd.com/va/orderDetail/${erpOrderId}?jdreactkey=JDReactMovie&jdreactmodule=JDReactMovie&rn_transparentenable=true&rn_routerName=orderDetail&rn_erpOrderId=${erpOrderId}`,
                title: `电影【${res.data.movieName}】京东购票更优惠`,
                msg: '你的好友刚撸了这部影片，更多影片等你来撩！'
                // logo: res.data.jdPicAddr,
            };
		        console.log('订单详情', res);
		        const shadowBean = res?.data?.busiType === 2;
		        console.log('影豆详情', shadowBean);
            // 处理拼场电影
                // 1: '待付款',
                // 2: '出票中',
                // 3: '已取消',
                // 4: '出票失败',
                // 5: '已完成', // 出票成功
                // 6: '退款中',
                // 7: '退款成功',
                // 8: '等待付款确认'
            if(![1,3].includes(+res?.data?.orderStatus)){
                this.handleScheduledPlay(res);
            }
            this.setState({
                detailInfo: res,
                loading: false,
                shareInfo,
		            shadowBean
            }, () => {
                if (starLevel === res.data.starLevel) return;
                dispatch({
                    type: 'starLevel_change',
                    starLevel: res.data.starLevel
                });
            });

            global.order = {
                orderStatus: res.data.orderStatus,
                orderStatusDesc: res.data.orderStatusDesc,
                erpOrderId: erpOrderId
            };

            if(res && res.data){
                if(!res.data.jdPicAddr){
                    sgmReport('1002', {function_id: 'getAllOrderDetail',message:'数据未返回图片地址！'}, 3)
                }
            }

            console.log(shareInfo, '订单详情分享信息');
        }).catch(() => {
            this.setState({
                hasError: true
            });
        });

        if(!erpOrderId){
            sgmReport('1001', {function_id: 'getAllOrderDetail',message:'缺少参数erpOrderId'}, 3)
        }
    }

		getCardSize(e){
				// 没有高度的阶段才获取高度
				if (!this.state.detailsHeight) {
						// 屏幕高度
						let {  height } = Dimensions.get('window');
						const viewHeight = e.nativeEvent?.layout?.height || 100;
						const detailsHeight =  (height - viewHeight - 40)
						this.setState({
								detailsHeight
						})
				}

		}

    goPay() {
        mta('OrdDePay', 'Order', '', `${this.props.erpOrderId}`);
        const erpOrderId = this.props.erpOrderId;

        post('getPayUrl', { erpOrderId }).then(res => {
            if (res.data.url) {
                JDJumping.jumpToWeb(res.data.url).catch(err => tip(err));
            }
        });

        if(!erpOrderId){
            sgmReport('1001', {function_id: 'getPayUrl',message:'缺少参数erpOrderId'}, 3)
        }
    }

    /* 确定取消 */
    _agreeCancel() {
        this.setState({
            cancelOrder: false
        });
        const erpOrderId = this.props.erpOrderId;

        // 取消订单
        post('cancelMovieOrder', { erpOrderId }, true).then(res => {
            tip('订单取消成功');
            this.getDetail();
        }).catch(() => {
            tip('订单取消失败');
        });

        if(!erpOrderId){
            sgmReport('1001', {function_id: 'cancelMovieOrder',message:'缺少参数erpOrderId'}, 3)
        }
    }

    /* 关闭取消订单弹层 */
    _onClose() {
        this.setState({
            cancelOrder: false
        });
    }

    /* 取消订单 */
    _cancelOrder() {
        mta('OrdDeCancel', 'Order', `${this.props.erpOrderId}`);
        this.setState({
            cancelOrder: true
        });
    }

    getDate(timestamp) {
        const CurDate = new Date(parseInt(timestamp));

        const month = this.setFormat(CurDate.getMonth() + 1);

        const date = this.setFormat(CurDate.getDate());

        const hour = this.setFormat(CurDate.getHours());

        const minute = this.setFormat(CurDate.getMinutes());

        const day = new Array('周日', '周一', '周二', '周三', '周四', '周五', '周六')[CurDate.getDay()];

        return `${month}-${date}(${day}) | ${hour}:${minute}`;
    }

    setFormat(date) {
        return date > 9 ? date : '0' + date;
    }

    getLeftTime(timestamp, type) {
        const CurDate = new Date(parseInt(timestamp));

        return type == 'm' ? CurDate.getMinutes() : CurDate.getSeconds();
    }

    overDeadTime() {
        const now = (new Date()).getTime();

        const airTime = this.state.detailInfo.data.timestamp;

        if (now > airTime) {
            if (now - airTime > 900000) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    refresh() {
        const { theMovieId } = this.state;

        this.setState({
            hasError: false,
            loading: true
        });
        this.getDetail();
    }

    // 设置标题
    setTitle = (title) => {
        document.title = title;
    }

    // 修改zIndex值
    setZindexFun = (flag) => {
        this.setState({ setZindex: flag });
    }
    // 获取拼团影片信息
    // isScheduledPlay: false,
    // scheduledPlayStatus: 0,
    // scheduledPlayInfo: {},
    // 预约放映，产品定义的4种状态怎么映射：
    // orderStatus=7: 拼场失败，已退款(优先级最高)
    // orderStatus=6: 拼场失败，退款中(优先级最高)
    // progressStatus=2 & orderStatus=5: 拼场成功，已出票(优先级第2高)
    // progressStatus=1: 预约成功，拼场中(优先级第3)
    // progressStatus=2 & orderStatus=2: 拼场成功，出票中(优先级第4)
    handleScheduledPlay(movieInfo) {
        console.log('拼团电影返回信息', movieInfo)
        if(movieInfo.data && movieInfo.data.scheduledPlayInfoId){
            const { erpOrderId } = this.props;
            const { scheduledPlayStatusMap } = this.state;
            const { orderStatus, scheduledPlayInfoId, orderStatusDesc } = movieInfo.data;
            post('scheduledPlayInfo', { scheduledPlayInfoId }).then(res => {
                if (res.data) {
                    const { progressStatus } = res.data;
                    let scheduledPlayStatus = 0;
                    if(orderStatus === 7){
                        scheduledPlayStatus = 1;
                    }else if(orderStatus === 6){
                        scheduledPlayStatus = 2;
                    }else if(progressStatus === 2 && orderStatus === 5){
                        scheduledPlayStatus = 3;
                    }else if(progressStatus === 1){
                        scheduledPlayStatus = 4;
                    }else if(progressStatus === 2 && orderStatus === 2){
                        scheduledPlayStatus = 5;
                    }
                    this.setState({
                        scheduledPlayStatus,
                        isScheduledPlay: true,
                        scheduledPlayInfo: res.data
                    })
                    global.order = {
                        orderStatus: orderStatus,
                        orderStatusDesc: scheduledPlayStatusMap[scheduledPlayStatus] || orderStatusDesc,
                        erpOrderId: erpOrderId
                    };
                }
            });
        }
    }

    // 跳电影详情
    toMovieDetail = () => {
        const { movieId } = this.props;

        if (movieId) {
            this.context.router.toMovieDetail({ movieId });
        } else {
            this.context.router.toIndex();
        }
         mta('OrdMovieDetails', 'Order');
    }
}

class CountDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
            time: 0
        };
        this._timeOut = this._timeOut.bind(this);
		    this._cusCountDown = this._cusCountDown.bind(this);
    }

    render() {
        const { show } = this.state;

        const { timeOut, thetime, shadowBean } = this.props;

        const now = Date.now();

		    return (
				    show && <>
						    {
								    shadowBean
										    ? <View style={yd.dsTop}>
												    <JDText style={yd.dsStyle}>剩余:</JDText>
												    <JDCountDown
														    endDate={ now + Number(thetime) }
														    onEnd={ this._timeOut }
														    startDate={ now }
														    renderCountDown={ this._cusCountDown }
														    interval={ 1000 }
														    containerStyle={ { backgroundColor: 'transparent' } }
														    daysStyle={ yd.timeStyle }
														    daysTextStyle={ yd.timeStyle }
														    hoursStyle={ yd.timeStyle }
														    firstColonStyle={ yd.timeStyle }
														    minsStyle={ yd.timeStyle }
														    secondColonStyle={ yd.timeStyle }
														    secsStyle={ yd.timeStyle }
												    />
										    </View>
										    : <>
												    <JDImage
														    source={ img.bac }
														    style={ st.time }
												    >
														    <View style={ st.v_time }>
																    <JDImage style={ st.time_img } source={ img.time } />
																    <JDCountDown
																		    endDate={ now + Number(thetime) }
																		    onEnd={ this._timeOut }
																		    startDate={ now }
																		    renderCountDown={ this._cusCountDown }
																		    interval={ 1000 }
																		    containerStyle={ { backgroundColor: 'transparent' } }
																		    daysStyle={ st.txt }
																		    daysTextStyle={ st.txt }
																		    hoursStyle={ st.txt }
																		    firstColonStyle={ st.txt }
																		    minsStyle={ st.txt }
																		    secondColonStyle={ st.txt }
																		    secsStyle={ st.txt }
																    />
														    </View>
												    </JDImage>
										    </>
						    }
				    </>
		    );
    }

		_cusCountDown(countDownProps, leftTime) {
				const { shadowBean } = this.props;
				const minutes = parseInt(leftTime / 60 / 1000);
				const seconds = parseInt((leftTime / 1000) - (minutes * 60));
				return (
						<JDText style={ [shadowBean ? yd.dsStyle : st.time_txt] }>{complement(minutes)}:{complement(seconds)}</JDText>
				);
		}

    _timeOut() {
        const { style, timeOut } = this.props;

        this.setState({
            show: false
        });
        timeOut();
    }
}

// 影豆头部
class ShadowBeanHeader extends Component{
	constructor(props) {
		super(props);
		this.state = {
			backImg: 'https://img12.360buyimg.com/imagetools/jfs/t1/129917/8/33465/544/6390008eE4fa02c70/a40cd1087249f11e.png'
		};
		this.navBarRef = null
		this.props = props;
		this.goBack = this.goBack.bind(this);
	}
	render() {
		const { orderStatusText } = this.props
		return (
			this.props.shadowBean ? <View>
					<View style={ { flexDirection: 'row', justifyContent: 'center', marginTop: pt(15) } }>
							<JDText style={ yd.navHeaderContent }>{orderStatusText}</JDText>
					</View>
			</View> : <></>
		)
	}
	goBack(){
		this.props.goBack()
	}
}

//页面背景图
class PageBgt extends Component {
	constructor(props) {
		super(props);
		this.props = props
		this.state = {
			bgtImg: 'https://img13.360buyimg.com/imagetools/jfs/t1/55094/14/23589/42307/63aa8dcbF310c2d60/b7497e18929da70a.png'
		}
	}
	render() {
		return (
			this.props.shadowBean
				? <View style={yd.pageBgt}>
					<JDImage source={ {uri: this.state.bgtImg }} style={{ width: pt(375), height: pt(485) }}></JDImage>
				</View>
				: <></>
		)
	}
}
const img = {
	go_pay_btn: require('../img/order/go_pay_btn.png'),
	return_info_icon: require('../img/order/return_info_icon.png'),
	time: require('../img/order/time.png'),
	bac: require('../img/order/bac.png')
};

//影豆样式部分
const color =  StyleSheet.create({
	red: {
		backgroundColor:'red'
	},
	blue: {
		backgroundColor:'blue'
	},
	yellow: {
		backgroundColor:'yellow'
	},
	purple: {
		backgroundColor:'#5103b3'
	}
})
const yd =  StyleSheet.create({
	navHeaderLeft: {
		width: pt(9),
		height: pt(17),
		marginLeft: pt(14)
	},
	navHeaderContent: {
		fontWeight: 'bold',
		fontSize: pt(17),
		justifyContent: 'center',
		alignItems: 'center',
		textAlign: 'center'
	},
	cardBoxTop: {
		paddingLeft: pt(12),
		paddingRight: pt(12),
		paddingTop: pt(12),
		paddingBottom: pt(6)
	},
	cardBoxTopBox: {
		display: 'flex',
		flexDirection: 'row',
		backgroundColor: '#fff',
		borderRadius: pt(12),
		padding: pt(12)
	},
	cardBoxTopBoxLeft: {
		flex: 3,
	},
	cardBoxTopBoxLeftTitle: {
		fontSize: pt(16),
		fontWeight: 'bold',
		marginBottom: pt(15)
	},
	cardBoxTopBoxLeftTextGroup: {
		padding: pt(1),
	},
	grayTextTop: {
		flexDirection: 'row',
		marginBottom: pt(8),
		lineHeight: pt(17),
		height: pt(17)
	},
	grayText: {
		fontSize: pt(12),
		color: 'rgba(51,51,51,0.6)',
		fontWeight: 'normal',
		marginRight: pt(5)
	},
	grayTextValue: {
		fontSize: pt(12),
		color: 'rgba(51,51,51,1)',
		fontWeight: 'normal'
	},
	cardRightBox: {
		flex: 1,
		alignItems: 'flex-end'
	},
	cardRightImg: {
		width: pt(65),
		height: pt(87)
	},
	orderDetails: {
		padding: 1
	},
	timeTop: {
		justifyContent: 'center',
		alignItems: 'center'
	},
	timeStyle: {
		fontSize: pt(12),
		color: 'rgba(0,0,0,0.6)',
		marginTop: pt(4),
		marginBottom: pt(8)
	},
	dsTop: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent:'center',
		alignItems: 'center',
		fontSize: pt(12),
		color: 'rgba(0,0,0,0.6)',
	},
	dsStyle: {
		fontSize: pt(12),
		color: 'rgba(0,0,0,0.6)',
	},
	timeBtnGroup: {
		width: pt(200),
		flexDirection: 'row',
		justifyContent: 'space-between',
		backgroundColor: 'rgba(0,0,0,0)'
	},
	timeBtn: {
		width: pt(88),
		height: pt(25),
		borderRadius: pt(14),
		borderWidth: 1,
		borderColor: 'rgba(0,0,0,0.1)',
		textAlign: 'center',
		lineHeight: pt(25),
		fontSize: pt(12),
		backgroundColor: 'rgba(255,255,255,0.2)',
		overflow: 'hidden'
	},
	pageBgt: {
		position: 'absolute',
	}
})




const st = StyleSheet.create({
    context: {
        backgroundColor: '#f5f5f5',
		    width: pt(375),
		    flex: 1
    },
    info_wrap: {
        alignItems: 'center',
        borderRadius: pt(4),
        marginLeft: pt(10),
        marginRight: pt(10),
        marginTop: pt(13),
        backgroundColor: '#fff',
        marginBottom: pt(15),
        overflow: 'hidden'
    },
    info_box: {
        width: '100%',
        paddingTop: pt(15),
        paddingLeft: pt(15),
        paddingBottom: pt(20),
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    movie_img: {
        width: pt(65),
        height: pt(88),
        marginRight: pt(9)
    },
    infos: {
        justifyContent: 'space-around'
    },
    info_title: {
        fontSize: pt(16),
        color: 'rgba(0, 0, 0, 0.85)',
        fontWeight: 'bold'
    },
    info_detail: {
        fontSize: pt(12),
        color: '#666',
        backgroundColor: 'transparent'
    },
    status: {
        position: 'absolute',
        right: 0,
        top: pt(19),
        justifyContent: 'center',
        // alignItems: 'flex-start',
        overflow: 'hidden',
        borderTopLeftRadius: pt(15),
        borderBottomLeftRadius: pt(15),
        height: pt(29),
        backgroundColor: '#3287FF'
    },
    count: {
        position: 'absolute',
        right: 0,
        top: pt(19),
        justifyContent: 'center'
        // alignItems: 'flex-start',
    },
    status_txt: {
        justifyContent: 'center',
        paddingLeft: pt(13),
        paddingRight: pt(5),
        lineHeight: pt(29),
        color: '#fff',
        backgroundColor: 'transparent',
        fontSize: pt(12)
    },
    status_txt_blue: {
        backgroundColor: '#3287FF'
    },
    status_txt_grey: {
        backgroundColor: '#bbb'
    },
    opt: {
        height: pt(58),
        width: pt(355),
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        borderTopWidth: pt(1),
        borderTopColor: '#D3D3D3'
    },
    btn: {
        width: pt(165),
        height: pt(31)
    },
    btn_txt: {
        lineHeight: pt(30),
        backgroundColor: 'transparent',
        fontSize: pt(12),
        color: '#252525'
    },
    cancel: {
        backgroundColor: '#fff',
        borderWidth: pt(1),
        borderColor: '#ccc',
        borderRadius: pt(15),
        justifyContent: 'center',
        alignItems: 'center'
    },
    pay: {
        color: '#fff',
        backgroundColor: '#F10000'
    },
    ewm: {
        // borderTopColor: '#D3D3D3',
        // borderTopWidth: pt(1),
        width: pt(355),
        // paddingTop: pt(20),
        paddingBottom: pt(20),
        alignItems: 'center'
    },

    yzm: {
        backgroundColor: '#F5F7F8',
        margin: pt(15),
        marginTop: pt(0),
        borderRadius: pt(2),
        paddingVertical: pt(8),
        paddingLeft: pt(10),
        justifyContent: 'center',
        alignItems: 'center',
        width: pt(334)
    },
    ewm_img_wrap: {
        position: 'relative'
    },
    ewm_img: {
        width: pt(130),
        height: pt(130)
    },
    ewm_mask: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: pt(130),
        height: pt(130),
        backgroundColor: 'rgba(239,241,243,.71)'
    },
    return_success: {
        borderTopColor: 'rgba(0, 0, 0, 0.1)',
        borderTopWidth: pt(1),
        height: pt(41),
        width: pt(355),
        paddingLeft: pt(15),
        flexDirection: 'row',
        alignItems: 'center'
    },
    return_success_txt: {
        // height: pt(41),
        // lineHeight: pt(41),
        fontSize: pt(12),
        color: '#F56A00',
        marginLeft: pt(4)
    },
    b_pay: {
        color: '#fff',
        fontSize: pt(12)
    },
    b_img: {
        justifyContent: 'center',
        alignItems: 'center',
        height: pt(30),
        width: pt(80)
    },
    dialogBody: {
        padding: pt(20),
        justifyContent: 'center',
        alignItems: 'center'
    },
    c_title: {
        fontSize: pt(14),
        fontWeight: 'bold',
        paddingBottom: pt(10)
    },
    wrap: {
        flex: 1,
		    height: JDDevice.height,
		    backgroundColor: 'rgba(246,246,246,1)'
    },
    // 倒计时
    time: {
        height: pt(29),
        width: pt(70),
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomLeftRadius: pt(29),
        borderTopLeftRadius: pt(29)
    },
    v_time: {
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center'
    },
    time_img: {
        height: pt(16),
        width: pt(16),
        marginRight: pt(6)
    },
    time_txt: {
        fontSize: pt(13),
        backgroundColor: 'transparent',
        color: '#fff'
    },

    whiteText: {
        fontSize: pt(12),
        backgroundColor: 'transparent'
    },
    group_buying_tips: {
        justifyContent: 'flex-start',
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: pt(18),
        marginTop: pt(21)
    },
    group_buying_tips_text: {
        color: '#000000',
        fontSize: pt(18),
        fontFamily: 'PingFangSC-Medium'
    }
});

const score = state => {
    const { starLevel } = state.orderDetail;

    return { starLevel };
};

OrderDetail.contextTypes = {
    router: PropTypes.object
};

export default connect(score, null, null, { withRef: true })(OrderDetail);
